import RefreshIcon from '@mui/icons-material/Refresh';
import { Button } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

/**
 * Reload button component that refetches the list data.
 * Includes a 5-second disable timeout after clicking to prevent spam.
 */
export function RefreshButton({ onRefresh }: { onRefresh: () => void }) {
  const { $t } = useIntl();
  const [isDisabled, setIsDisabled] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    // Cleanup timeout on unmount
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleReload = async () => {
    setIsDisabled(true);

    try {
      onRefresh();
    } finally {
      // Set 5-second disable timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        setIsDisabled(false);
        timeoutRef.current = null;
      }, 3000);
    }
  };

  return (
    <Button
      size="small"
      variant="outlined"
      color="secondary"
      startIcon={<RefreshIcon />}
      onClick={handleReload}
      disabled={isDisabled}
    >
      {$t({
        id: 'common.actions.refresh',
        defaultMessage: 'Refrescar',
      })}
    </Button>
  );
}
